import React from "react";

// components
import MarketingMessageModal from "./MarketingMessageModal";

// hooks
import { useAuth } from "frontend/hooks/useAuth";

// component
const MarketingMessageModalWrapper = () => {
    const { marketingMessageModal } = useAuth();
    const { userMessage } = marketingMessageModal;
    if (!userMessage) return null;
    return <MarketingMessageModal userMessage={userMessage} />;
};

export default MarketingMessageModalWrapper;
